import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image,
  url,
  type = 'website'
}) => {
  const siteName = 'AJ BIM Portal';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Cursos e Consultoria BIM`;
  const defaultDescription = 'Líder em Educação BIM no Brasil. Cursos de Revit, Navisworks e metodologia BIM. +12.000 alunos formados desde 2005.';
  const finalDescription = description || defaultDescription;
  const defaultKeywords = 'BIM, Revit, cursos BIM, Autodesk, Navisworks, consultoria BIM, treinamento Revit';
  const finalKeywords = keywords || defaultKeywords;
  
  // Use dynamic URLs based on current origin
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const canonicalUrl = url || baseUrl;
  const ogImage = image || `${baseUrl}/og-image.jpg`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="pt_BR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
